export const ALERT_INSERT = 'ALERT_INSERT';
export const ALERT_DELETE = 'ALERT_DELETE';
export const ALERT_ON = 'ALERT_ON';
export const ALERT_OFF = 'ALERT_OFF';
export const ALERT_SWITCH_SETTING = 'ALERT_SWITCH_SETTING';
export const ALERT_SWITCH_CHANGE = 'ALERT_SWITCH_CHANGE';
export const ALERT_CONFIRM_INSERT = 'ALERT_CONFIRM_INSERT';
export const ALERT_CONFIRM_DELETE = 'ALERT_CONFIRM_DELETE';
export const ALERT_LIST_INSERT = 'ALERT_LIST_INSERT';

export const warningAlertInsert = (data) => {
  return {
    type: ALERT_INSERT,
    data,
  };
};

export const warningAlertDelete = () => {
  return {
    type: ALERT_DELETE,
  };
};

export const warningAlertOn = () => {
  return {
    type: ALERT_ON,
  };
};

export const warningAlertOff = () => {
  return {
    type: ALERT_OFF,
  };
};

export const warningAlertSwitchSetting = () => {
  return {
    type: ALERT_SWITCH_SETTING,
  };
};

export const warningAlertSwitchChange = () => {
  return {
    type: ALERT_SWITCH_CHANGE,
  };
};

export const warningAlertConfirmInsert = (data) => {
  return {
    type: ALERT_CONFIRM_INSERT,
    ...data,
  };
};

export const warningAlertConfirmDelete = (data) => {
  return {
    type: ALERT_CONFIRM_DELETE,
    ...data,
  };
};

export const warningAlertListDelete = (data) => {
  return {
    type: ALERT_LIST_INSERT,
    ...data,
  };
};

const initialState = {
  status: false,
  switch: true,
  alert: {},
  confirm: [],
};

export const warningAlert = (state = initialState, action) => {
  switch (action.type) {
    case 'ALERT_INSERT':
      if (action.data.confirm) {
        return {
          ...state,
          alert: {
            ...state.alert,
            [action.data.moduleIdx]: action.data,
          },
        };
      } else {
        return {
          ...state,
        };
      }
    case 'ALERT_ON':
      return {
        ...state,
        status: true,
      };
    case 'ALERT_OFF':
      return {
        ...state,
        status: false,
      };
    case 'ALERT_SWITCH_SETTING':
      return {
        ...state,
        switch: true,
      };
    case 'ALERT_SWITCH_CHANGE':
      return {
        ...state,
        switch: !state.switch,
      };
    case 'ALERT_SWITCH_OFF':
      return {
        ...state,
        status: false,
      };
    case 'ALERT_LIST_INSERT':
      return {
        ...state,
        alert: action.data,
      };
    case 'ALERT_DELETE':
      return {
        ...state,
        alert: {},
      };
    case 'ALERT_CONFIRM_INSERT':
      return {
        ...state,
        confirm: [...state.confirm, !state.confirm.includes(action.idx) && action.idx],
      };
    case 'ALERT_CONFIRM_DELETE':
      return {
        ...state,
        confirm: state.confirm.filter((idx) => idx !== action.idx),
      };
    default:
      return state;
  }
};
